import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { DeferredConfigModel, InitialConfigModel, SessionInfoModel } from '../../models';
import { StartUpConfigService } from '../data/start-up-config.service';
import { LocalDataCacheService } from '../storage/local-data-cache.service';

@Injectable({
  providedIn: 'root'
})
export class StartUpConfigUiService {
  constructor(private startupConfig: StartUpConfigService, private storage: LocalDataCacheService) {

  }
  public deferredConfig$: Observable<DeferredConfigModel> = this.startupConfig.getDeferredConfig().pipe(take(1), publishLast(), refCount());
  public initialConfig$: Observable<InitialConfigModel> = this.startupConfig.getInitialConfig().pipe(take(1), publishLast(), refCount());
  public sessionInfo$: Observable<SessionInfoModel> = this.startupConfig.getSessionConfig().pipe(take(1), publishLast(), refCount());

  private cjUrlKey: string = "cjUrl";
  private cmsUrlKey: string = "cmsUrl";
  private baseAssetsUrlKey: string = "baseAssetsUrl";

  //When Session is Expired, SessionExpired counter insert API is triggered.
  //This variable tracks, for what SessionTrackingID, this API have been triggered, to avoid redundancy of Tracker.
  private sessionExpiryTriggeredFor: string[] = [];

  //The CJUrl should be saved in localstorage for the situations, when session expired and
  //user need to be redirected to CJUrl.
  public cjUrl$: Observable<string> = this.initialConfig$
    .pipe(map(initialConfig => initialConfig != null && initialConfig.urlConfig != null
      ? initialConfig.urlConfig.cjUrl
      : this.storage.getLocalStorage().getItem(this.cjUrlKey)));

  public sessionTrackingId$: Observable<string> = this.sessionInfo$
    .pipe(map(sessionInfo => sessionInfo != null ? sessionInfo.sessionTrackingId : null));

  public sessionExpiryPollingFrequency$: Observable<number> = this.sessionInfo$
    .pipe(map(sessionInfo => sessionInfo != null ? sessionInfo.sessionExpiryPollingFrequency : null));
  //The CMS Url should be saved in localstorage for the situations, when session expired and
  //user need to be redirected to CJUrl.
  public cmsUrl$: Observable<string> = this.initialConfig$
    .pipe(map(initialConfig => initialConfig != null && initialConfig.urlConfig != null
      ? initialConfig.urlConfig.cmsUrl
      : this.storage.getLocalStorage().getItem(this.cmsUrlKey)));

  //The BaseAssetsUrl should be saved in localstorage for the situations, when session expired and
  //user need to be redirected to BaseAssetsUrl.
  public baseAssetsUrl$: Observable<string> = this.initialConfig$
    .pipe(map(initialConfig => initialConfig != null && initialConfig.urlConfig != null
      ? initialConfig.urlConfig.baseAssetsUrl
      : this.storage.getLocalStorage().getItem(this.baseAssetsUrlKey)));
  public hasSessionExpiryTriggeredFor(sessionTrackingId: string): boolean {
    return this.sessionExpiryTriggeredFor.filter(function (x) { return x == sessionTrackingId }).length > 0;
  }

  public addSessionExpiryTrigger(sessionTrackingId: string) {
    this.sessionExpiryTriggeredFor.push(sessionTrackingId);
  }
  public getPreloaderImageUrl(): Observable<string> {
    return this.initialConfig$
      .pipe(map(x => {
        return x.urlConfig.baseImageUrl + "shared/waitimage.gif";
      }));
  }

}
